import { render } from "./BookingComments.vue?vue&type=template&id=b0eae40c"
import script from "./BookingComments.vue?vue&type=script&lang=js"
export * from "./BookingComments.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/BookingComments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b0eae40c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b0eae40c', __exports__)) {
    api.reload('b0eae40c', __exports__)
  }
  
  module.hot.accept("./BookingComments.vue?vue&type=template&id=b0eae40c", () => {
    api.rerender('b0eae40c', render)
  })

}


export default __exports__